import { Event } from '.';
const FoquzEvent = Event();

const FolderCreateEvent = FoquzEvent.get('folder.create');
const FolderDeleteEvent = FoquzEvent.get('folder.delete');
export { FolderCreateEvent, FolderDeleteEvent };
